export default "__VITE_ASSET__CIGzFnYP__"